<div class="dropdown-container lib-dropdown">
  @if (preIcon) {
    <span class="material-icons preicon">
      {{ preIcon }}
    </span>
  }

  <mat-form-field
    class="admin-form-field-outline admin-form-field-outline--shadow"
    [ngClass]="classAdditions"
    [appearance]="appearance"
    [floatLabel]="floatLabel"
    [class.small]="small"
    [class.tiny]="tiny"
    [class.readonly]="readonly">
    @if (label) {
      <mat-label>
        {{ label }}
        @if (isRequired) {
          *
        }
      </mat-label>
    }

    <mat-select
      #select
      [panelClass]="long ? 'lib-dropdown-long' : 'lib-dropdown'"
      [ngModel]="value"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [multiple]="multiple"
      (selectionChange)="onSelectionChange($event)"
      (openedChange)="onOpenedChange($event)">
      @if ((!displayFn && !multiple) || (!displayFn && multiple && !value?.length)) {
        <mat-select-trigger>
          @if (!showSvgImages) {
            <p [class.need-bold]="isBold">
              {{ translateMe ? translateMe + value : value }}
            </p>
          }
          @if (showSvgImages) {
            <div class="svg-images">
              <img
                style="border-radius: 3px; border: 1px solid lightgrey"
                [src]="'/assets/svgs/flags/' + value + '.svg'"
                [alt]="'Flag of ' + value" />
            </div>
          }
        </mat-select-trigger>
      }

      @if (multiple && value?.length > 1) {
        <mat-select-trigger>
          <p>
            <i>
              Selected:
              <b>{{ value.length }}</b>
            </i>
          </p>
        </mat-select-trigger>
      }

      @if (withSearch) {
        <div class="filter-container">
          @if (loading) {
            <div class="loading">
              <importer-app-turbine
                [withPole]="false"
                [shadow]="false"></importer-app-turbine>
            </div>
          }
          @if (multiple && !selectAllDisabled && !showSortIndicator) {
            <mat-checkbox
              class="check-all"
              (change)="selectAll($event.checked)"></mat-checkbox>
          }
          @if (showSortIndicator) {
            <div
              class="sort-direction-indicator"
              (click)="isAscSort = !isAscSort">
              @if (isAscSort) {
                <mat-icon>south</mat-icon>
              }
              @if (!isAscSort) {
                <mat-icon>north</mat-icon>
              }
              <p class="sort-indicator">{{ isAscSort ? 'Asc' : 'Desc' }}</p>
            </div>
          }
          <coin-v2-text-input
            #searchField
            label="Search"
            addClass="shadow"
            class="search-input"
            (input)="searchChanged(searchField.viewValue())"
            (keydown)="$event.stopPropagation()"></coin-v2-text-input>
        </div>
      }

      @if (!lazyLoadFn) {
        @for (itm of filteredAndSortedItems; track itm) {
          <mat-option
            [class.disabled]="isDisabled(itm)"
            [value]="itm"
            [disabled]="isDisabled(itm)">
            @if (!showSvgImages) {
              <p [class.need-bold]="isBold">
                {{ translateMe ? translateMe + getText(itm) : getText(itm) }}
              </p>
            }
            @if (showSvgImages) {
              <div style="height: 20px; width: 30px; margin-left: auto; margin-right: auto">
                <img
                  style="border-radius: 3px"
                  [src]="'/assets/svgs/flags/' + itm + '.svg'"
                  [alt]="'Flag of ' + itm" />
              </div>
            }
          </mat-option>
        }
      } @else {
        @for (itm of lazyLoadedItems$ | async; track itm) {
          <mat-option [value]="itm">
            @if (!showSvgImages) {
              <p [class.need-bold]="isBold">
                {{ translateMe ? translateMe + getText(itm) : getText(itm) }}
              </p>
            }
            @if (showSvgImages) {
              <div style="height: 20px; width: 30px; margin-left: auto; margin-right: auto">
                <img
                  style="border-radius: 3px"
                  [src]="'/assets/svgs/flags/' + itm + '.svg'"
                  [alt]="'Flag of ' + itm" />
              </div>
            }
          </mat-option>
        }
      }

      @if (!lazyLoadFn ? !filteredAndSortedItems?.length : !(lazyLoadedItems$ | async)?.length) {
        <p style="padding: 10px 20px 20px">- - - -</p>
      }

      @if (showApplyButton) {
        <div class="button-container">
          <div class="inner-container">
            <coin-v2-button
              [type]="'primary'"
              [icon]="'chevron_right'"
              [iconPos]="'right'"
              [text]="bottomButtonText"
              (click)="onPressApply()"></coin-v2-button>
          </div>
        </div>
      }
    </mat-select>
  </mat-form-field>

  @if (afterIcon) {
    <span class="material-icons aftericon">
      {{ afterIcon }}
    </span>
  }
  @if (canDeselect && value) {
    <mat-icon
      class="remove"
      (click)="onPressRemove()">
      cancel
    </mat-icon>
  }
</div>
